import { Pagination as MuiPagination } from "@material-ui/lab";
import { Box, Theme, useMediaQuery } from "@material-ui/core";
import React, { FC } from "react";
import styled from "styled-components/macro";
import {
  ChevronLeft,
  ChevronRight
} from "react-feather";


const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin-top: 18px;
  background: #18212E;
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  height: 48px;
  padding: 0 16px;
`


const Pagination = styled(MuiPagination)`
  li:last-child, li:first-child {
    display: none;
  }
  .MuiPaginationItem-outlined {
    border: none;
    color: #818181;
  }
  .Mui-selected {
    border: 1px solid #F1F3F4;
    background: transparent;
    color: white
  }
`

const InfoWrapper = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  color: #818181;
  b {
    padding: 0 5px;
  }
`

const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`

const Button = styled.button`
  height: 32px;
  width: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: linear-gradient(90deg,#84FAB0 0%,#8FEAFE 100%);
`

type PropsType = {
  count: number,
  page: number,
  onChangePage: (page: number) => void
}

const PaginationBlock: FC<PropsType> = ({count, page, onChangePage}) => {
  const sm = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  const handlerButtons = (button: 'prev' | 'next') => {
    if (button === 'next') {
      if (page < Math.ceil(count / 8)) {
        onChangePage(page + 1)
      }
    }
    if (button === 'prev') {
      if (page !== 1) {
        onChangePage(page - 1)
      }
    }
  }

  return (
    <Wrapper>
      <InfoWrapper>
        Showing <b>{page * 8 - 8 === 0 ? 1 : page * 8 - 8 + 1}-{page * 8 > count ? count : page * 8}</b> of {count} items
      </InfoWrapper>
      <PaginationWrapper>
        <Pagination
          variant="outlined"
          size={sm ? "small" : "medium"}
          count={Math.ceil(count / 8)}
          page={page}
          onChange={(event, newPage) => (
            onChangePage(newPage)
          )}
          showFirstButton={false}
          showLastButton={false}
        />
      </PaginationWrapper>
      <ButtonsWrapper>
        <Button
          style={{marginRight: '12px'}}
          onClick={() => handlerButtons('prev')}
        >
          <ChevronLeft size={16} color='black'/>
        </Button>
        <Button
          onClick={() => handlerButtons('next')}
        >
          <ChevronRight size={16} color='black'/>
        </Button>
      </ButtonsWrapper>
    </Wrapper>
  )
}

export default PaginationBlock
